module.exports = __webpack_public_path__ + "static/media/naver-map.38541fd9.png";